import {useQuery, useQueryClient} from "@tanstack/react-query";
import {useEffect} from "react";
import getTokenBetbyService from "../services/games/betby/getToken.service";
import useBetbyStore from "../store/Betby/useBetbyStore.store";

const useGetTokenBetby = (lang, currency, isAuth = false) => {
  const setTokenBetby = useBetbyStore(state => state.setTokenBetby);
  const query = useQueryClient();
  const {data, isSuccess, refetch, isLoading} = useQuery({
    queryKey: ["tokenBetby", lang, currency],
    queryFn: () => getTokenBetbyService(lang, currency),
    staleTime: 10 * 60 * 1000, // 10 minutes (was 0 — refetched on every mount)
    gcTime: 15 * 60 * 1000, // 15 minutes (was 0)
    refetchOnMount: true, // only refetch if stale (was "always")
    enabled: !!isAuth,
  });

  const invalidateQuery = () => {
    query.invalidateQueries({queryKey: ["tokenBetby", lang, currency]});
  };

  useEffect(() => {
    if (data?.data?.token) {
      setTokenBetby(data?.data?.token);
    }
  }, [data, isSuccess]);

  return {
    isLoading,
    isSuccess,
    refetch,
    invalidateQuery,
  };
};

export default useGetTokenBetby;
